module.exports = __webpack_public_path__ + "blood-pressure-chart.7a993261fc121ec74e3ba3ae5f10ad17.png";